/* ============================================================
   Logbuch Verlag — Lieferbox auf der Produktdetailseite
   Ablage:    assets/logbuch-pdp.js
   Einbinden: layout/theme.liquid vor </head>
     <script src="{{ 'logbuch-pdp.js' | asset_url }}" defer></script>

   Ergänzt den Kalles-order-Block um zwei Zeilen:
     1) berechnetes Lieferdatum inkl. Cut-off
     2) Fortschritt bis zum kostenlosen Versand

   Ohne dieses Script bleibt die Karte mit der Statuszeile stehen —
   es ist additiv, nichts bricht.

   Nutzt ausschließlich dokumentierte Shopify-Ajax-Endpunkte:
     /cart.js            und
     /products/<handle>.js
   ------------------------------------------------------------
   NICHT LIVE GETESTET. Vor dem Ausrollen auf einer Vorschau prüfen.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Konfiguration ------------------------------- */
  var CONFIG = {
    cutoffHour: 14,          // Bestellungen bis 14:00 gehen am selben Tag raus
    minWorkdays: 1,          // frühester Zustelltag nach Versand
    maxWorkdays: 3,          // spätester Zustelltag nach Versand
    freeShippingCents: 4990, // 49,90 €
    // true: Preis und MwSt.-Zeile stehen direkt über Menge und
    // Button, also unter der Variantenauswahl.
    priceAtForm: true,
    // false: Lieferbox bleibt an ihrer Stelle im Template, also
    // oberhalb des Formulars — damit über Auswahl, Preis und Button.
    // true: sie rutscht unter das Formular.
    deliveryBelowForm: false,
    // Versand- und zustellfreie Tage, Format 'YYYY-MM-DD'.
    // MUSS gepflegt werden — Feiertage verschieben die Zusage.
    holidays: []
  };

  var WEEKDAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  /* ---------- Hilfsfunktionen ----------------------------- */
  function iso(d) {
    return d.getFullYear() + '-' +
      ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
      ('0' + d.getDate()).slice(-2);
  }

  function isWorkday(d) {
    var w = d.getDay();
    if (w === 0 || w === 6) return false;
    return CONFIG.holidays.indexOf(iso(d)) === -1;
  }

  function addWorkdays(from, n) {
    var cur = new Date(from.getTime());
    var c = 0;
    var guard = 0;
    while (c < n && guard < 60) {
      cur.setDate(cur.getDate() + 1);
      guard++;
      if (isWorkday(cur)) c++;
    }
    return cur;
  }

  function fmt(d) {
    return WEEKDAYS[d.getDay()] + ', ' +
      ('0' + d.getDate()).slice(-2) + '.' +
      ('0' + (d.getMonth() + 1)).slice(-2) + '.';
  }

  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* ---------- 1  Statuszeile einpacken -------------------- */
  function wrapStatus(box) {
    if (box.querySelector('.lbv-deliv-status')) return;
    var span = el('span', 'lbv-deliv-status');
    while (box.firstChild) span.appendChild(box.firstChild);
    box.appendChild(span);
  }

  /* ---------- 2  Lieferdatum ------------------------------ */
  function renderDate(box) {
    var now = new Date();
    var ship = new Date(now.getTime());

    // Nach Cut-off oder an einem versandfreien Tag: nächster Werktag
    if (now.getHours() >= CONFIG.cutoffHour || !isWorkday(ship)) {
      ship = addWorkdays(ship, 1);
    }

    var from = addWorkdays(ship, CONFIG.minWorkdays);
    var to = addWorkdays(ship, CONFIG.maxWorkdays);

    var sameDay = isWorkday(now) && now.getHours() < CONFIG.cutoffHour;
    var cut = sameDay
      ? 'Bestellungen bis ' + CONFIG.cutoffHour + ' Uhr gehen heute raus'
      : 'Versand am ' + fmt(ship).replace(',', '');

    var line = el('div', 'lbv-deliv-date',
      '<span>Lieferung <b>' + fmt(from) + ' – ' + fmt(to) + '</b>' +
      '<span class="lbv-deliv-cut">' + cut + '</span></span>');

    box.appendChild(line);
  }

  /* ---------- 3  Fortschritt bis Gratisversand ------------ */
  function currentVariantCents() {
    // Kalles liefert die Varianten-ID je nach Auswahlmodus als
    // <input name="id"> ODER als verstecktes <select name="id">.
    // Nur auf input zu prüfen hat den Versandfortschritt bei
    // Dropdown-Produkten ausfallen lassen.
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var handleMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!input || !handleMatch) return Promise.resolve(null);

    return fetch('/products/' + handleMatch[1] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return null;
        var id = parseInt(input.value, 10);
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].id === id) return p.variants[i].price;
        }
        return p.variants[0].price;
      })
      .catch(function () { return null; });
  }

  function qty() {
    var q = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (isNaN(n) || n < 1) ? 1 : n;
  }

  var freeRun = 0;   // verwirft Ergebnisse überholter Durchläufe

  function renderFreeShipping(box) {
    var run = ++freeRun;

    var cartP = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });

    Promise.all([cartP, currentVariantCents()]).then(function (res) {
      if (run !== freeRun) return;         // eine neue Auswahl ist schon unterwegs
      var cart = res[0];
      var unit = res[1];
      if (!cart || unit == null) return;   // keine Halbwahrheit anzeigen

      var total = cart.total_price + unit * qty();
      var missing = CONFIG.freeShippingCents - total;
      var pct = Math.max(0, Math.min(100, Math.round(total / CONFIG.freeShippingCents * 100)));

      var text = missing > 0
        ? 'Mit diesem Artikel: noch <b>' + euro(missing) + '</b> bis zum kostenlosen Versand'
        : '<b>Kostenloser Versand</b> ist mit diesem Artikel erreicht';

      var wrap = el('div', 'lbv-deliv-free', text);
      var bar = el('div', 'lbv-deliv-bar', '<span style="width:' + pct + '%"></span>');
      wrap.appendChild(bar);

      var old = box.querySelector('.lbv-deliv-free');
      if (old) old.replaceWith(wrap); else box.appendChild(wrap);
    });
  }

  /* ---------- 4  Neu rechnen bei Varianten- / Mengenwechsel -
     Bei Variantenprodukten ändert sich der Stückpreis und damit der
     Abstand zum kostenlosen Versand. Das Theme tauscht dabei den
     Wert von input[name="id"] per Property — das löst kein
     Attribut-Ereignis aus. Deshalb wird auf die Bedienelemente
     gehört: Klick auf einen Swatch, change am versteckten Select
     und change am Mengenfeld. Kurze Verzögerung, damit das Theme
     die neue Variante gesetzt hat. */
  function bindRecalc(box) {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var t = null;
    var again = function () {
      clearTimeout(t);
      t = setTimeout(function () { renderFreeShipping(box); }, 400);
    };

    form.addEventListener('click', function (e) {
      if (e.target.closest('.t4s-swatch__item, .t4s-quantity-wrapper')) again();
    });
    form.addEventListener('change', again);
  }

  /* ---------- Hinweis: kein Ausblenden des Bewertungs-Widgets
     Eine frühere Fassung hat das eTrusted-Widget ausgeblendet, wenn
     es scheinbar leer war. Das war falsch: eTrusted rendert in einen
     geschlossenen Shadow-Root, auf den weder innerText noch
     element.shadowRoot noch querySelector zugreifen können. Vorhandene
     Bewertungen sahen damit "leer" aus und verschwanden nach 5 s.
     Das Widget wird jetzt nie angefasst; ohne Bewertungen bleibt
     lediglich eine schmale Leerstelle.
     ------------------------------------------------------------- */

  /* ---------- 5  Preisblock zur Auswahl herunterziehen -----
     Gewünschte Reihenfolge: Produktdetails → Auswahl → Preis →
     inkl. MwSt. → Menge + Button → Lieferung.

     Zwei Fälle, gleiches Ergebnis:
     • Variantenprodukt — die Form bringt einen eigenen Preis mit,
       der sich beim Wechsel aktualisiert. Er bleibt, wo er ist;
       der Preisblock oben (die Spanne, die sich NICHT aktualisiert)
       wird ausgeblendet.
     • Ohne Varianten — es gibt nur den Preisblock oben. Er wandert
       in die Form, direkt über Menge und Button.
     Die Zeile "inkl. MwSt. & KOSTENLOSER Versand ab 49,90 €" folgt
     in beiden Fällen direkt auf den Preis.

     An keinem dieser Elemente hängen Theme-Ereignisse, deshalb ist
     das Verschieben unkritisch. Abschalten über CONFIG.priceAtForm. */
  function arrangePriceBlock() {
    if (!CONFIG.priceAtForm) return;

    var form = document.querySelector('.t4s-form__product');
    if (!form) return;
    var buttons = form.querySelector('.t4s-product-form__buttons');
    if (!buttons) return;

    var priceRow = document.querySelector('.t4s-product__price-review');
    var taxLine = document.querySelector('[class*="t4s-richtext_text_R4LDkA"]');
    var variantPrice = null;
    for (var i = 0; i < form.children.length; i++) {
      if (form.children[i].classList.contains('t4s-product-price')) {
        variantPrice = form.children[i];
        break;
      }
    }

    if (variantPrice) {
      if (priceRow) priceRow.classList.add('lbv-price-hidden');
    } else if (priceRow) {
      buttons.parentNode.insertBefore(priceRow, buttons);
    }

    if (taxLine) buttons.parentNode.insertBefore(taxLine, buttons);
  }

  /* ---------- 6  Lieferbox unter das Formular --------------
     Die Variantenauswahl steckt im Formular und lässt sich nicht
     herauslösen. Damit die Reihenfolge trotzdem stimmt — erst
     wählen, dann Lieferzusage — wandert stattdessen die Lieferbox
     hinter das Formular. Beide sind Geschwister im selben
     Container, das Verschieben braucht keinen Theme-Eingriff und
     an der Box hängen keine Theme-Ereignisse.
     Abschalten über CONFIG.deliveryBelowForm. */
  function moveDeliveryBelowForm(box) {
    if (!CONFIG.deliveryBelowForm) return;
    var form = document.querySelector('.t4s-product-form__variants');
    if (!form || form.parentNode !== box.parentNode) return;
    form.parentNode.insertBefore(box, form.nextSibling);
  }

  /* ---------- 7  Produktdaten-Tabelle einsetzen ------------
     Die Tabelle aus den Metafeldern (custom.material, custom.grosse, …)
     rendert die Section custom_liquid_lbvSpecs unterhalb des
     Produktbereichs — eine Section kann nicht in die Buy-Box. Hier
     wandert sie in die Beschreibung, zwischen Bullets und
     Artikelnummer. Gibt es keine Beschreibung, steht sie über der
     Lieferbox. Ohne befüllte Metafelder existiert sie gar nicht. */
  function placeSpecs() {
    var specs = document.querySelector('[data-lbv-specs]');
    if (!specs || specs.classList.contains('is-placed')) return;

    var rte = document.querySelector('.t4s-product__info-container .t4s-product__description .t4s-rte');
    if (rte) {
      rte.appendChild(specs);
    } else {
      var anchor = document.querySelector('.t4s-product__info-container .t4s-pr_delivery');
      if (!anchor) return;
      anchor.parentNode.insertBefore(specs, anchor);
    }
    specs.classList.add('is-placed');
  }

  /* ---------- 8  Theme-Tab „Inhaltsstoffe & Nährwerte" ausblenden
     Der Inhalt steht jetzt als Aufklappbar unter „Auf einen Blick".
     Das Theme rendert ihn zusätzlich als Tab mit dem Anker
     #t4s_tab_inhaltsstoffe. Entfernt wird er nur, wenn unser
     Aufklappbar wirklich existiert — sonst bliebe die Info unsichtbar. */
  function hideIngredientsTab() {
    if (!document.querySelector('[data-lbv-ingredients]')) return;
    var links = document.querySelectorAll('a[href="#t4s_tab_inhaltsstoffe"]');
    for (var i = 0; i < links.length; i++) {
      var holder = links[i].closest('.t4s-tab-wrapper, li');
      if (holder) holder.style.display = 'none';
    }
    var panel = document.getElementById('t4s_tab_inhaltsstoffe');
    if (panel) panel.style.display = 'none';
  }

  /* ---------- Start --------------------------------------- */
  function init() {
    arrangePriceBlock();
    placeSpecs();
    hideIngredientsTab();

    var box = document.querySelector('.t4s-pr_delivery');
    if (!box || box.dataset.lbvDone) return;
    box.dataset.lbvDone = '1';

    moveDeliveryBelowForm(box);
    wrapStatus(box);
    renderDate(box);
    renderFreeShipping(box);
    bindRecalc(box);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();